<template>
  <div>
    <a-table
      class="mb-20"
      :columns="columnsAccess"
      :data-source="dataAcess"
      :pagination="false"
      :loading="loading"
      bordered
      size="small"
    >
      <template slot="type" slot-scope="text, record">
        <a-tag :color="record.location_detail.check_type === 'in' ? 'green' : 'red' ">{{ record.location_detail.check_type }}</a-tag>
      </template>
      <template slot="device" slot-scope="text, record">
        {{ record.input_type }}
      </template>
      <template slot="location" slot-scope="text, record">
        {{ record.location_detail.location }}
      </template>
      <template slot="building" slot-scope="text, record">
        {{ record.location_detail.building }}
      </template>
      <template slot="time" slot-scope="text, record">
        {{ moment(record.created_at).format("DD / MM / YYYY HH:mm:ss") }}
      </template>
    </a-table>
    <a-pagination
      class="mb-10 mt-5"
      :current="currentPage"
      :total="countObjData"
      @change="onChangePage"
    />
  </div>
</template>

<script>
const columnsAccess = [
  {
    title: "Type",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
    className: "text-center",
    customHeaderRow: "text-center",
  },
  {
    title: "Device",
    dataIndex: "device",
    scopedSlots: { customRender: "device" },
    className: "text-center",
  },
  {
    title: "Location",
    dataIndex: "location",
    scopedSlots: { customRender: "location" },
  },
  {
    title: "Building",
    dataIndex: "building",
    scopedSlots: { customRender: "building" },
  },
  {
    title: "Time stamp",
    dataIndex: "time",
    scopedSlots: { customRender: "time" },
    sorter: true,
  },
];
export default {
  data() {
    return {
      columnsAccess,
      dataAcess: [],
      loading: false,
      // pagination
      perPage: 10,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
    };
  },
  mounted() {
    this.getListAccess();
  },
  methods: {
    onChangePage(current) {
      this.currentPage = current;
      this.offset = Number.parseInt(current - 1) * Number.parseInt(this.perPage);
      this.getListAccess();
    },
    async getListAccess() {
      this.loading = true;
      this.dataAcess = [];
      try {
        const res = await this.$http.get(
          `/checkcovid19/QR/history/?limit=${this.perPage}&offset=${this.offset}`
        );
        if (res.status === 200) {
          this.dataAcess = res.data.results.map((item) => ({ ...item }));
          this.countObjData = res.data.count;
          this.offset = 0;
          this.loading = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataAcess = [];
        this.loading = false;
        this.$notification.open({
          style: {
            backgroundColor: `#ff1919`,
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error ${error.response.status}`)]);
          },
          description: `Problem issue connect api : /checkcovid19/QR/history/?limit=${this.perPage}&offset=${this.offset}`,
        });
      }
    },
  },
};
</script>